import React from 'react';

export const FormControl = () => {
    return {
        handleChange: () => {},
        valid: false,
        dirty: false,
        elements: {},
        registerFormElement: () => {},
        isFormElementRegistered: () => {},
        updateFormElement: () => {}
    }
};

export const FormContext = React.createContext(FormControl());